import { render, staticRenderFns } from "./OurAbility.vue?vue&type=template&id=b33b7396&scoped=true&"
import script from "./OurAbility.vue?vue&type=script&lang=js&"
export * from "./OurAbility.vue?vue&type=script&lang=js&"
import style0 from "./OurAbility.vue?vue&type=style&index=0&id=b33b7396&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b7396",
  null
  
)

export default component.exports